// Module for smooth animations
const internals = {};

internals.doAnimation = (element) => {
  const effect = element.dataset.effect;
  const duration = element.dataset.duration;

  element.classList.remove('animateElem');
  element.classList.add(duration, effect);
  ['data-effect', 'data-duration'].forEach((attribute) => {
    element.removeAttribute(attribute);
  });
};

internals.onChange = (changes, observer) => {
  changes.forEach(change => {
    if (change.intersectionRatio > 0) {
      // Stop watching and load animation
      internals.doAnimation(change.target);
      observer.unobserve(change.target);
    }
  });
};

const animateElements = () => {

  const elements = document.querySelectorAll('.animateElem');

  // If ${elements} is an empty array, prevent further execution
  if (!elements.length) {
    return 0;
  }

  if ('IntersectionObserver' in window) {
    // IntersectionObserver Supported
    const config = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };

    const observer = new IntersectionObserver(internals.onChange, config);

    elements.forEach((domElement) => observer.observe(domElement));
  } else {

    elements.forEach((domElement) => internals.doAnimation(domElement));
  }

  return 0;
};

export default animateElements;
